import axios from 'axios';
import { API_BASE } from '@/config/apiBase'

// 登录请求方法
const loginreq = (method, url, params) => {
    console.log(params);
    return axios({
        method: method,
        url: API_BASE + url,
        // headers: {
        //     'Content-Type': 'application/x-www-form-urlencoded',
        // },
        data: params,
        traditional: true,
        transformRequest: [
            function (data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};


/* // 通用公用方法
const req = (method, url, params) => {
    return axios({
        method: method,
        // url: "http://106.15.199.41:8088" + url,
        // url: "http://192.168.1.118:8088" + url,
        url: "http://192.168.1.8:8088" + url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: localStorage.getItem('userdata')
        },
        data: params,
        traditional: true,
        transformRequest: [
            function (data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
}; */

const req = (method, url, params = {}) => {
    const config = {
        method: method,
        url: API_BASE + url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: localStorage.getItem('userdata')
        },
        traditional: true,
    };

    // 打印请求信息
    console.log('请求方法:', method);
    console.log('请求URL:', url);
    console.log('请求参数:', params);

    if (method.toLowerCase() === 'get') {
        config.params = params;
    } else {
        config.data = params;
        config.transformRequest = [
            function (data) {
                if (!data) return '';

                let ret = '';
                for (let it in data) {
                    if (data.hasOwnProperty(it)) {
                        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
                    }
                }
                console.log('转换后的参数:', ret);
                return ret.slice(0, -1);
            }
        ];
    }

    return axios(config).then(res => {
        console.log('响应数据:', res.data);
        return res.data;
    }).catch(error => {
        console.error('请求错误:', error);
        throw error;
    });
};




const reqJson = (method, url, params) => {
    return axios({
        method: method,
        url: API_BASE + url,

        headers: {
            'Content-Type': 'application/json',
            token: localStorage.getItem('userdata')
        },
        data: params,
        traditional: true,
        // transformRequest: [
        //     function(data) {
        //         let ret = ''
        //         for (let it in data) {
        //             ret +=
        //                 encodeURIComponent(it) +
        //                 '=' +
        //                 encodeURIComponent(data[it]) +
        //                 '&'
        //         }
        //         return ret
        //     }
        // ]
    }).then(res => res.data);
};



export {
    loginreq,
    req,
    reqJson
}


// WEBPACK FOOTER //
// ./src/api/axiosFun.js